module.exports = __webpack_public_path__ + "img/header_square.9af1f6b4.png";